import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-copy-standard",
  "use": "icon-copy-standard-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-copy-standard\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 10L6 18H14H16C16 19.1046 15.1046 20 14 20H6C4.89543 20 4 19.1046 4 18V10C4 8.89543 4.89543 8 6 8V10Z\" fill=\"currentColor\" />\n<path d=\"M9 6H17C17.5523 6 18 6.44772 18 7V15C18 15.5523 17.5523 16 17 16H9C8.44772 16 8 15.5523 8 15V7C8 6.44772 8.44772 6 9 6Z\" stroke=\"currentColor\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol